import React from 'react'
import gql from 'graphql-tag'
import RouteAdminFeaturesGroupsIndexQuery from 'routes/admin/features/groups/index.query'
import { Mutation } from 'react-apollo'

const DELETE_GROUP = gql`
  mutation DeleteGroupMutation($input: DeleteGroupInput!) {
    deleteGroup(input: $input) {
      deletedGroupId
    }
  }
`

const DeleteFeatureGroupMutation = ({ children, group }) => (
  <Mutation mutation={DELETE_GROUP}>
    {(mutation, props) =>
      children({
        ...props,
        deleteGroup: () =>
          mutation({
            variables: { input: { groupId: group.id } },
            update: cache => {
              const { groups } = cache.readQuery({
                query: RouteAdminFeaturesGroupsIndexQuery
              })

              cache.writeQuery({
                query: RouteAdminFeaturesGroupsIndexQuery,
                data: {
                  groups: groups.filter(fg => fg.id !== group.id)
                }
              })
            }
          })
      })
    }
  </Mutation>
)

export default DeleteFeatureGroupMutation



// WEBPACK FOOTER //
// ./src/components/mutations/DeleteFeatureGroup.js